import "./tree/node.js";
import { dispatchAction } from "./tree/tree.js";
//#region src/inspector.ts
/**
* Subscribes to inspector commands targeting this tree.
*
* Commands mirror the protocol used between the library and the inspector UI.
*/
function subscribeToInspectorCommands(tree, callback) {
	if (typeof window === "undefined") return;
	window.addEventListener("message", (event) => {
		if (event.data.type === "fiveway:command" && (event.data.command.tree === tree.label || event.data.command.tree === "*")) callback(event.data.command);
	});
}
const queue = [];
let scheduledFlush = null;
function emitInspectorMessage(message) {
	if (typeof window === "undefined") return;
	queue.push(message);
	if (scheduledFlush == null) scheduledFlush = Promise.resolve().then(flushQueue).finally(() => {
		scheduledFlush = null;
	});
}
/**
* Converts an internal node into the inspector wire format.
*/
function inspectNode(node, handler = false) {
	const children = [];
	for (const child of node.children) if (child.active) children.push(child.id);
	return {
		id: node.id,
		parent: node.parent,
		order: node.order,
		children,
		handler: handler ? inspectHandler(node.tree, node.id) : void 0
	};
}
const INSPECT_QUERY_KEY = "inspect";
function describeHandler(action, info) {
	if (action.kind === "query" && action.key === "inspect") {
		if (!Array.isArray(action.value)) action.value = [];
		action.value.push(info);
	}
}
function inspectHandler(tree, id) {
	const action = {
		kind: "query",
		key: INSPECT_QUERY_KEY,
		value: []
	};
	dispatchAction(tree, action, id);
	return action.value;
}
function flushQueue() {
	const batched = {};
	for (const message of queue) {
		const current = batched[message.tree];
		if (current != null) mergeMessages(current, message);
		else batched[message.tree] = message;
	}
	queue.length = 0;
	for (const message of Object.values(batched)) window.postMessage(message);
}
function mergeMessages(current, incoming) {
	if (incoming.focus != null) current.focus = incoming.focus;
	if (incoming.nodes != null) {
		current.nodes ??= [];
		for (const node of incoming.nodes) {
			const existing = current.nodes.findIndex((n) => n.id === node.id);
			if (existing !== -1) current.nodes[existing] = node;
			else current.nodes.push(node);
		}
		if (current.removedNodes != null) {
			const incomingNodes = incoming.nodes;
			current.removedNodes = current.removedNodes.filter((id) => !incomingNodes.some((node) => node.id === id));
		}
	}
	if (incoming.removedNodes != null) {
		current.removedNodes ??= [];
		for (const id of incoming.removedNodes) if (!current.removedNodes.includes(id)) current.removedNodes.push(id);
		if (current.nodes != null) {
			const removed = incoming.removedNodes ?? [];
			current.nodes = current.nodes.filter((node) => !removed.includes(node.id));
		}
	}
}
//#endregion
export { INSPECT_QUERY_KEY, describeHandler, emitInspectorMessage, inspectHandler, inspectNode, subscribeToInspectorCommands };

//# sourceMappingURL=inspector.js.map